import { connect } from 'react-redux';
import Barbers from './components/Barbers';
import * as barberSelectors from '../../main/barbers/selector';


const mapStateToProps = state => ({
  barbers: barberSelectors.getAll(state),
});

export default connect(mapStateToProps)(Barbers);
